<script>
  import { tl } from "../multilang.js";
  import { status } from "../status.js";
  import page from "page";

  let hasWhiteBackgroundFooter = ['', '/','/documentation','/privacy', '/terms'];
  
  function doNavigation(url) {
    window.scrollTo(0,0);
    page(url);
  }
  
</script>
<footer class="footer" class:has-background-white={(hasWhiteBackgroundFooter.indexOf($status.path) != -1)}>
  <div class="content has-text-centered">
  <p>
  {tl("Copyright © 2024 ZofToken. All rights reserved.")} 
  </p>
    <p>
      <a href="https://zoftoken.com" target="_blank">{tl("ZofToken website")}</a>
      <!-- <a on:click={() => doNavigation('/privacy')}>{tl("Privacy policy")}</a>
      <a class="divider" on:click={() => doNavigation('/terms')}>{tl("Terms & conditions")}</a> -->
      <span class="language-wrapper">{tl("Select language")}: 
        <a class:disabled={$status.language == -1} on:click={() => {$status.language = -1; location.reload()}}>{tl("English")}</a>
        <a class:disabled={$status.language == 0} on:click={() => {$status.language = 0; location.reload()}}>{tl("Spanish")}</a>
      </span>
    </p>
  </div>
</footer>